import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const Dropdown = ({ onToggle, assetDropdown, title, modified, children }) => {
  return (
    <li className="relative group z-50">
      <button
        onClick={onToggle}
        className="flex items-center text-base text-white/80 hover:text-white transition"
      >
        {title || null}
        <FontAwesomeIcon
          icon={!assetDropdown ? faChevronDown : faChevronUp}
          className="ml-1 text-sm"
        />
      </button>
      {assetDropdown && (
        <motion.ul
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className={`absolute left-0 w-48 bg-gray-900 rounded-xl shadow-lg z-50 w-[120px] ${modified ? "top-15 right-3" : "top-8"}`}
        >
          <div className={`${modified && "w-1/2"}`}>{children}</div>
        </motion.ul>
      )}
    </li>
  );
};

export default Dropdown;
